import { useContext } from "react";
import { AuthContext } from "../providers/AuthProvider";

export function useAuth() {
  const {
    token,
    setToken,
    isLoginlessAccessToken,
    loginEmail,
    setLoginEmail,
    otpSubmitError,
    setOTPSubmitError,
    emailSubmitError,
    setEmailSubmitError,
    deleteToken,
  } = useContext(AuthContext);

  return {
    token,
    setToken,
    isLoginlessAccessToken,
    loginEmail,
    setLoginEmail,
    otpSubmitError,
    setOTPSubmitError,
    emailSubmitError,
    setEmailSubmitError,
    deleteToken,
  };
}
